import React, { Component, Fragment } from "react";
import Navbar from "../partials/Navbar";
import Sidebar from "../partials/Sidebar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList } from "@fortawesome/free-solid-svg-icons/faList";
import ReactDatatable from '@mkikets/react-datatable';
import PropTypes from "prop-types";
import { connect } from "react-redux";
import axios from "axios";
// import { Link } from "react-router-dom";
// import { faPlus } from "@fortawesome/free-solid-svg-icons";
// import AddContest from "../partials/AddContest";
import { toast, ToastContainer } from "react-toastify";
import Moment from 'moment';
import * as myConstList from "./baseUrl"

const baseUrl = myConstList.baseUrl
const token = localStorage.getItem("jwtToken");
const configs = {
  headers: {
    Authorization: `Bearer ${token}`,
  },
};
class AutoOrder extends Component {

    constructor(props) {
        super(props);
        this.state = {
            FilterRecords:[]
        }

        this.columns = [
            {
                // key: "id",
                text: "SN",
                className: "id",
                align: "left",
                sortable: true,
                cell: (row, index) => index + 1
            },
            // {
            //     key: "firstName",
            //     text: "Name",
            //     className: "user_id",
            //     align: "left",
            //     sortable: true
            // },
            {
                key: "email",
                text: "Email",
                className: "email",
                align: "left",
                sortable: true,
                cell: record => {
                    return (
                        <Fragment>
                            {record.UserId.email}
                        </Fragment>
                    );
                }
            },
            {
                key: "mobile_no",
                text: "Mobile No.",
                className: "email",
                align: "left",
                sortable: true,
                cell: record => {
                    return (
                        <Fragment>
                            {record.UserId.mobilenumber}
                        </Fragment>
                    );
                }
            },
            {
                key: "Purchaseprice",
                text: "Buy Price",
                className: "amount",
                align: "left",
                sortable: true,
            },
            {
                key: "qty",
                text: "Quantity",
                className: "amount",
                align: "left",
                sortable: true,
            },
            {
                key: "Trade",
                text: "Trade Amount",
                className: "price",
                align: "left",
                sortable: true,
            },
          
           
            {
                key: "firstCoin",
                text: "Pair",
                className: "stopLoss",
                align: "left",
                sortable: true,
                cell: record => {
                    console.log("records",record)
                    return (
                        <Fragment>
                            {record.PairId.firstCoin.shortName}/{record.PairId.secondCoin.shortName}
                        </Fragment>
                    );
                }
            },
            {
                key: "Status",
                text: "Status",
                className: "status",
                align: "left",
                sortable: true
            },
            {
                key: "orderStatus",
                text: "Order Status",
                className: "status",
                align: "left",
                sortable: true
            },
            {
                key: "orderType",
                text: "Order Type",
                className: "status",
                align: "left",
                sortable: true
            },
            {
                key: "created",
                text: "Date & Time",
                className: "date",
                align: "left",
                sortable: true,
                cell: record => {
                    return (
                        <Fragment>
                            {Moment.utc(record.created).local().format("lll")}
                        </Fragment>
                    );
                }
            },

        ];

        this.config = {
            page_size: 10,
            length_menu: [10, 20, 50],
            filename: "Buy Order List",
            no_data_text: 'No user found!',
            button: {

                // print: true,
                // csv: true
            },
            language: {
                length_menu: "Show _MENU_ result per page",
                filter: "Search in records...",
                info: "Showing _START_ to _END_ of _TOTAL_ records",
                pagination: {
                    first: "First",
                    previous: "Previous",
                    next: "Next",
                    last: "Last"
                }
            },
            show_length_menu: true,
            show_filter: true,
            show_pagination: true,
            show_info: true,
        };

        this.state = {
            records: []
        };
        this.getData = this.getData.bind(this);
    }
    componentDidMount() {
        if (this.props.auth.user.buyOrder !== undefined && this.props.auth.user.buyOrder !== 1) {
            this.props.history.push("/dashboard");
        }
        this.getData()
    };
    componentWillReceiveProps(nextProps) {
        if (nextProps.auth.user.buyOrder !== undefined && nextProps.auth.user.buyOrder !== 1) {
            this.props.history.push("/dashboard");
        }
        this.getData()
    }
    getData() {
        axios
            .post(baseUrl + "/api/v1/getautochart", { search: "Auto" },configs)
            .then(res => {
                this.setState({ records: res.data.result })
            })
            .catch()
    }
    // editRecord(record) {
    //     this.setState({ currentRecord: record });
    // }
    componentDidUpdate(){
        console.log("FilterRecordsdsdss",this.state.FilterRecords)
    }
    // deleteRecord(record) {
    //     axios
    //         .post(baseUrl + "/api/order-delete", { _id: record._id })
    //         .then(res => {
    //             if (res.status === 200) {
    //                 toast(res.data.message, {
    //                     position: toast.POSITION.TOP_CENTER,
    //                 })
    //             }
    //         })
    //         .catch();
    //     this.getData();
    // }
    pageChange(pageData) {
        console.log("OnPageChange", pageData);
    }

    // supportClick = (e) => {
    //     var html = []
    //         this.state.records.map((value,i) => {
    //             if (e.target.value == "pending") {
    //                 if (value.status === "pending") {
    //                     console.log("valuevaluevaluevalue",value,e.target.value)
    //                     html.push(value)
    //                 }
    //             }
    //             if (e.target.value === "completed") {
    //                 if (value.status == "completed") {
    //                     html.push(value)
    //                 }
    //             }
    //             if (e.target.value === "deleted") {
    //                 if (value.status == "deleted") {
    //                     html.push(value)
    //                 }
    //             }
    //             if (e.target.value == "edited") {
    //                 if (value.status == "edited") {
    //                     html.push(value)
    
    //                 }
    //             }
    //             if (e.target.value === "select") {
    
    //                 html.push(value)
    
    
    //             }
    
    //         })
        

       
    //     this.setState({ FilterRecords: html })

    // }

    // showFilterList = () => {


    //     const html = []

    //     html.push(
    //         <select className="form-control" id="exchange" name="supportFilter" onClick={this.supportClick}>
    //             <option value="select" id="">Select Status</option>
    //             <option value="pending">Pending</option>
    //             <option value="edited">Edited</option>
    //             <option value="deleted">Deleted</option>
    //             <option value="completed">Completed</option>
    //         </select>
    //     );


    //     return <div className="support-select">{html}</div>


    // }

    render() {
        return (
            <div>
                <Navbar />
                <div className="d-flex" id="wrapper">
                    <Sidebar />
                    
                    <div id="page-content-wrapper">
                        <div className="container-fluid">
                            <button className="btn btn-link mt-3" id="menu-toggle"><FontAwesomeIcon icon={faList} /></button>

                            <h4 className="mt-2 man_hadding mb-3">Buy Order</h4>
                            {/* {this.showFilterList()} */}
                            {console.log('FilterRecordssdsasaddsadsa', this.state.FilterRecords)}
                            <ReactDatatable
                                config={this.config}
                                records={this.state.FilterRecords ? this.state.FilterRecords : this.state.records}
                                columns={this.columns}
                                onPageChange={this.pageChange.bind(this)}
                            />
                        </div>
                    </div>
                    <ToastContainer />
                </div>
            </div>
        );
    }

}

AutoOrder.propTypes = {
    auth: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
    auth: state.auth,
    records: state.records
});

export default connect(
    mapStateToProps
)(AutoOrder);
